/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { DetailedUserDto } from '../api/users/usersClient.typings';

export enum SettingsUserInfoActionType {
    OPEN_SETTINGS_USER_INFO_PAGE = 'SettingsUserInfo/ open page',
    EXIT_SETTINGS_USER_INFO_PAGE = 'SettingsUserInfo/ exit page',

    UPDATE_USER_INFO = 'SettingsUserInfo/ update user info',

    FETCH_USER_INFO_SUCCESS = 'SettingsUserInfo/ fetch user info success',
    FETCH_USER_INFO_ERROR = 'SettingsUserInfo/ fetch user info error',
}

export const openUserInfoPageAction = () => createAction(SettingsUserInfoActionType.OPEN_SETTINGS_USER_INFO_PAGE);

export const exitUserInfoPageAction = () => createAction(SettingsUserInfoActionType.EXIT_SETTINGS_USER_INFO_PAGE);

export const updateUserInfoAction = (payload: Partial<DetailedUserDto>) =>
    createAction(SettingsUserInfoActionType.UPDATE_USER_INFO, payload);

export const fetchUserInfoSuccessAction = (payload: DetailedUserDto) =>
    createAction(SettingsUserInfoActionType.FETCH_USER_INFO_SUCCESS, payload);

export const fetchUserInfoErrorAction = (notification: Notification) =>
    createAction(SettingsUserInfoActionType.FETCH_USER_INFO_ERROR, { notification });

export type SettingsUserInfoAction =
    | ReturnType<typeof openUserInfoPageAction>
    | ReturnType<typeof exitUserInfoPageAction>
    | ReturnType<typeof fetchUserInfoSuccessAction>
    | ReturnType<typeof fetchUserInfoErrorAction>
    | ReturnType<typeof updateUserInfoAction>;
